import { useFetcher } from "~/hooks/useFetcher";

const { VITE_ACCESS_CONTROLLER_API } = import.meta.env;

interface UserStats {
  enabled_users_count: number;
  current_month_active_user_count: number;
  includes_system_users: boolean;
}

const useUserStats = () => {
  return useFetcher<UserStats>(
    `${VITE_ACCESS_CONTROLLER_API}/users/stats?include_system_users=false`
  );
};

export default useUserStats;
